export * from './cdn-img';